import InfiniteScroll from "react-infinite-scroll-component";
import { MessageResponse } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";
import { PendingActionCard } from "../PendingActionCard";
import { SmallEmptyOpenBox } from "../SmallEmptyOpenBox";

export const ActionCentreList = ({
  actionMessageItems,
  loadNextPage,
  next,
  groupId,
  completed,
  emptyStateText,
  alignToCenter,
  onStatusUpdateClick,
}: {
  actionMessageItems: Array<{
    message: MessageResponse<DefaultStreamChatGenerics> & {
      custom_data: CustomData;
    };
  }>;
  loadNextPage: () => void;
  next: boolean | null;
  groupId: string;
  completed?: boolean;
  emptyStateText: string;
  alignToCenter?: boolean;
  onStatusUpdateClick?: (
    message: MessageResponse<DefaultStreamChatGenerics> & {
      custom_data: CustomData;
    }
  ) => void;
}) => {
  const noActionFound = !actionMessageItems || actionMessageItems.length === 0;

  if (noActionFound) {
    return (
      <div className="t-h-fit t-w-full t-flex t-justify-center t-items-center">
        <SmallEmptyOpenBox
          text={emptyStateText}
          alignToCenter={alignToCenter}
        />
      </div>
    );
  }
  return (
    <InfiniteScroll
      dataLength={actionMessageItems.length}
      next={loadNextPage}
      hasMore={Boolean(next)}
      scrollThreshold={0.6}
      scrollableTarget="pending-actions"
      loader={
        <div className="t-w-full t-pb-2 t-text-center t-text-subtitle-sm">
          Loading...
        </div>
      }
    >
      <div className="t-flex t-flex-col t-gap-4 t-pb-5">
        {actionMessageItems.map(({ message }) => (
          <PendingActionCard
            message={
              message as MessageResponse<DefaultStreamChatGenerics> & {
                custom_data: CustomData;
              }
            }
            key={message.id}
            groupId={groupId}
            completed={completed}
            onStatusUpdateClick={onStatusUpdateClick}
          />
        ))}
      </div>
    </InfiniteScroll>
  );
};
